import { Props_SnippetCareers } from './Careers.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const Careers = (props: Props_SnippetCareers) => {
    const {
        heading,
        content,
        repeatable_careerItems: items = [],
    } = props

    const isHeadingVisible = heading?.visibility?.value;
    const headingContent = heading?.text?.value;
    const contentValue = content?.text?.value;

    return (
        <section className="snippet-careers">
            <div className="snippet-careers__container">
                <div className="snippet-careers__card">
                    <div className="snippet-careers__intro">
                        {isHeadingVisible && headingContent && (
                            <div className="snippet-careers__heading">
                                {CompileMarkdown(headingContent)}
                            </div>
                        )}
                        {contentValue && (
                            <div className="snippet-careers__text">
                                {CompileMarkdown(contentValue)}
                            </div>
                        )}
                    </div>

                    <ul className="snippet-careers__items">
                        {items.map((item, index) => (
                            <li key={"career-item-" + index} className="snippet-careers__item">
                                {(item.iconDesktop?.value || item.iconMobile?.value) && (
                                    <div className="snippet-careers__icon-container">
                                        <picture>
                                            {item.iconMobile?.value && (
                                                <source
                                                    media="(max-width: 768px)"
                                                    srcSet={item.iconMobile.value}
                                                />
                                            )}
                                            <img
                                                loading="lazy"
                                                src={item.iconDesktop?.value || item.iconMobile?.value}
                                                alt=""
                                                className="snippet-careers__icon"
                                                width="48"
                                                height="48"
                                            />
                                        </picture>
                                    </div>
                                )}
                                <div className="snippet-careers__item-content">
                                    {item.captionTop?.value && (
                                        <p className="snippet-careers__item-caption-top">
                                            {item.captionTop.value}
                                        </p>
                                    )}
                                    {item.captionBottom?.value && (
                                        <p className="snippet-careers__item-caption-bottom">
                                            {item.captionBottom.value}
                                        </p>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default Careers